<template>
    <div style="margin-bottom: 20px;">
        <div v-if="subscription && renewSubscription == false">

            <div class="alert alert-danger" style="margin-top: 10px; text-align: center;"
                 v-if="subscription.paymentError === true">
                <h3>Important</h3>
                Une erreur est survenue lors du paiement ou renouvellement de votre abonnement. Veuillez corriger le
                problème pour continuer à profiter
                de vos privilèges du Club.
            </div>

            <h3>Informations sur l'adhésion</h3>
            <p class="explication">
                Si vous désirez annuler ou modifier votre adhésion, veuillez contacter le COQ par courriel
                <a href="mailto:coq@coq.qc.ca">(coq@coq.qc.ca)</a> ou par la poste.
            </p>

            <table class="table">
                <tr>
                    <th>Numéro de membre</th>
                    <td>{{ user.memberNumber }}</td>
                </tr>
                <tr>
                    <th>Date de début du cycle courant</th>
                    <td>{{ subscription.startDate || formatDate }}</td>
                </tr>
                <tr>
                    <th>Date de fin du cycle courant</th>
                    <td>{{ subscription.endDate || formatDate }}</td>
                </tr>
                <tr>
                    <th>Nombre de jours restants</th>
                    <td>{{ daysRemaining }}</td>
                </tr>
                <tr>
                    <th>Type</th>
                    <td>{{ subscription.subscriptionType.name }}</td>
                </tr>
            </table>

            <a
                    class="btn btn-primary"
                    style="width: 100%;"
                    v-if="daysRemaining <= 30"
                    @click="renewSubscription = true"
            >
                Renouveler mon abonnement
            </a>
        </div>
        <div v-else>
            <h3>Adhésion au Club des ornithologues de Québec</h3>
            <p>
                L'adhésion au Club apporte plusieurs avantages.
                <br/>
                Vous trouverez l'ensemble de ceux-ci en cliquant ici :
                <router-link class="collapsed" :to="{ name: 'DevenirMembrePage' }">
                    Avantages/Devenir membre
                </router-link>
                <br/><br/>
                Voici la liste des forfaits offerts par le COQ :
                <br/><br/>
            </p>

            <table class="table">
                <thead>
                <th>Type</th>
                <th>Durée</th>
                <th style="min-width: 100px;">Prix (+tx)</th>
                <th>Description</th>
                <th></th>
                </thead>
                <tbody>
                <tr v-for="_type in subscriptionTypes">
                    <th>
                        {{ _type.name.split('-')[0] }}
                    </th>
                    <td>
                        <template v-if="_type.durationInYear === 1">
                            1 an
                        </template>
                        <template v-else>
                            {{ _type.durationInYear }} ans
                        </template>
                    </td>
                    <td>{{ _type.price | formatMoney }}</td>
                    <td>
                        {{ _type.description }}
                    </td>
                    <td>
                        <b-button
                                disabled
                                :variant="subscription && subscription.subscriptionType.id === _type.id ? 'success' : 'primary'"
                                style="width: 100%"
                        >
                            <template v-if="subscription && subscription.subscriptionType.id === _type.id ">
                                Renouveller
                            </template>
                            <template v-else>
                                Adhérer
                            </template>
                        </b-button>
                    </td>
                </tr>
                </tbody>
            </table>

            <template v-if="subscription">
                <b-button variant="danger" @click="renewSubscription = false" style="width: 100%">Annuler</b-button>
            </template>

            <br/><br/>

        </div>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex';
  import moment from 'moment';
  import config from '../../config';
  import Panier_Payer from '@/components/Panier/Panier_Payer.vue';

  export default {
    name: 'SubscriptionInfo',
    data() {
      return {
        type: 'individual',
        subscriptionTypes: null,
        renewSubscription: false
      };
    },
    async mounted() {
      await this.fetchSubscriptionTypes();
    },
    computed: {
      ...mapGetters('account', {
        getUserInfos: 'getUserInfos'
      }),
      user() {
        return this.getUserInfos;
      },
      subscription() {
        const user = this.getUserInfos;
        if (user) {
          return user.subscription; // user.subscription;
        }
        return null;
      },
      daysRemaining() {
        let days = moment(this.subscription.endDate).diff(moment(), 'days');
        if (days < 0) {
          days = 0;
        }
        return days;
      }
    },
    methods: {

      ...mapActions('account', {
        _subscribeToPlan: 'subscribeToPlan'
      }),

      async fetchSubscriptionTypes() {
        const requestOptions = {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        };

        return fetch(`${config.apiUrl}/subscription-types`, requestOptions)
          .then((response) => {
            return response.text().then(text => {
              this.subscriptionTypes = _.sortBy(JSON.parse(text), 'order');
            });
          });
      },

      async subscribeToPlan(plan) {
        this.$modal.show(Panier_Payer, {
          onSuccess: () => this.processSubscription(plan),
          title: 'Paiement ' + (this.renewSubscription ? 'du renouvellement' : "de l'adhésion")
        }, {
          height: 'auto',
          width: 500,
          clickToClose: false,
          name: 'subscription-payment',
          root: this.$root
        });
      },

      async processSubscription(planId) {
        try {
          await this._subscribeToPlan(planId);
          this.success = true;

          this.$swal.fire({
            title: 'Succès',
            text: 'Votre adhésion a été inscrite avec succès. Veuillez patienter quelques secondes.',
            type: 'success',
            showConfirmButton: false,
            showCancelButton: false,
            showCloseButton: false,
            allowOutsideClick: false
          });

          setTimeout(() => {
            // Reload the page
            window.location.reload();
          }, 5000);
        }
        catch (e) {
          await this.$swal.fire({
            title: 'Problème',
            text: 'Votre carte a été refusée. Veuillez réessayer avec une autre carte de crédit.',
            type: 'error',
            confirmButtonText: 'Fermer'
          });
        }
      }
    }
  };
</script>

<style scoped lang="scss">
table {
  width: 100%;
}

.btn {
  color: white !important;
  font-style: normal;
  margin-top: 5px;
  margin-right: 5px;
  font-size: 12px;
}

h3 {
  margin-top: 10px;
  margin-bottom: 20px;
}

p {
  margin-left: 0;
  padding-left: 0;
}

select {
  ::placeholder {
    color: gray;
  }
}

.explication {
  margin-bottom: 10px;
  margin-top: 10px;
  text-align: center;
  color: dimgray;
}
</style>
